import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { ClientAbsence, GetClientAbsencesOptions } from 'RestAPIs/absence';
import { getClientAbsenceReasons, getClientAbsences } from 'RestAPIs/absence';
import { requests } from 'RestAPIs/rapini';
import type {
  PlanningEntityIdentifier,
  PlanningEntityType
} from 'generated/index';

export const useGetClientAbsences = (
  { clientId, startDate, endDate }: GetClientAbsencesOptions,
  options?: Record<string, unknown>
): UseQueryResult<ClientAbsence[]> => {
  return useQuery(
    ['client-absences', clientId],
    async () => {
      const { data } = await getClientAbsences({
        clientId,
        startDate,
        endDate
      });

      return data;
    },
    options
  );
};

export const useGetClientAbsenceReasons = (
  options?: Record<string, unknown>
) => {
  return useQuery(
    ['client-absence-reasons'],
    async () => {
      const { data } = await getClientAbsenceReasons();

      return data.sort((a, b) => a.name.localeCompare(b.name));
    },
    { ...options }
  );
};

export const useGetPlanning = (
  startDate: string,
  endDate: string,
  organizationalUnitPlanningEntityPerspective: PlanningEntityType,
  planningEntityIdentifiers: PlanningEntityIdentifier[],
  options?: Record<string, unknown>,
  dependencies?: unknown[]
) => {
  return useQuery(
    [
      'planning',
      startDate,
      endDate,
      organizationalUnitPlanningEntityPerspective,
      planningEntityIdentifiers,
      ...(dependencies || [])
    ],
    async () => {
      return await requests.getPlanning({
        startDate,
        endDate,
        organizationalUnitPlanningEntityPerspective,
        planningEntityIdentifiers
      });
    },
    { ...options }
  );
};
